import { APP } from "common-types";

export function getSkin(app: string): string {
  switch (app) {
    case APP.FANDOM_DESKTOP:
      return "ucp_desktop";
    case APP.FANDOM_MOBILE:
      return "ucp_mobile";
    default:
      return app;
  }
}
